import React from "react";

import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { ConstructDestinationUrl } from "../construct-destination-url";

export const CNN5Things = () => (
  <ConstructDestinationUrl platform={NorthbeamUtmPlatform.CNN5_THINGS} />
);
